/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DepTypeEnum } from './DepTypeEnum';
import { DepTypeEnumFromJSON, DepTypeEnumFromJSONTyped, DepTypeEnumToJSON } from './DepTypeEnum';

/**
 *
 * @export
 * @interface Department
 */
export interface Department {
  /**
   *
   * @type {number}
   * @memberof Department
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof Department
   */
  name: string;
  /**
   *
   * @type {DepTypeEnum}
   * @memberof Department
   */
  depType: DepTypeEnum;
}

/**
 * Check if a given object implements the Department interface.
 */
export function instanceOfDepartment(value: object): value is Department {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('depType' in value) || value['depType'] === undefined) return false;
  return true;
}

export function DepartmentFromJSON(json: any): Department {
  return DepartmentFromJSONTyped(json, false);
}

export function DepartmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Department {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    depType: DepTypeEnumFromJSON(json['dep_type']),
  };
}

export function DepartmentToJSON(value?: Omit<Department, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    dep_type: DepTypeEnumToJSON(value['depType']),
  };
}
